/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { AI_STRINGS } from '../../../Constants/Strings.constants';

import React from 'react';
import { escape } from 'lodash';
import { TestToolProps } from '../TestTool.props';
import { ChatUI } from '@squiz/chat-ui';
import { getAiService } from '../../../Services/ai';
import { useTranslation } from 'react-i18next';

export const ChatbotTest = ({ contentTool }: TestToolProps): JSX.Element => {
  const aiService = getAiService();
  const { t } = useTranslation();

  const labels = {
    testChatbotOutputPlaceholder: t(AI_STRINGS.testChatbotOutputPlaceholder, {
      instructions: escape(contentTool.instruction),
    }),
  };

  return (
    <div className="chatbot-test-container" data-testid="chatbot-test-container">
      <span className="chatbot-test-heading-text">Conversation</span>
      <ChatUI
        aiId={contentTool.id}
        aiService={aiService.apiClient}
        greeting={labels.testChatbotOutputPlaceholder}
        isPreview
      />
    </div>
  );
};
